<template>
  <div>
    <data-table
      v-if="type===1&&urlParams.indexOf('isHeadlines')===-1"
      ref="datatablelist"
      :module-info="moduleInfo"
      :tb-columns="tbColumns"
      :toolbar-btns="listpageBtns"
      :on-cell-click="onCellClick"
      :on-list-data-before-load="onListDataBeforeLoad"
      :on-list-data-loaded="onListDataLoaded"
      :on-delete-successed="onDeleteSuccessed"
      :on-selected-rows-change="onSelectedRowsChange"
    />
    <div v-if="type===2||urlParams.indexOf('isHeadlines') > -1" class="app-container">
      <data-table
        ref="datatablelist"
        :module-info="moduleInfo"
        :tb-columns="tbColumns"
        :toolbar-btns="listpageBtns"
        :on-cell-click="onCellClick"
        :on-list-data-before-load="onListDataBeforeLoad"
        :on-list-data-loaded="onListDataLoaded"
        :on-delete-successed="onDeleteSuccessed"
        :on-selected-rows-change="onSelectedRowsChange"
      />
    </div>
    <data-table
      v-if="type===3 || type===4"
      ref="datatablelist"
      :module-info="moduleInfo"
      :tb-columns="tbColumns"
      :toolbar-btns="listpageBtns"
      :on-cell-click="onCellClick"
      :on-list-data-before-load="onListDataBeforeLoad"
      :on-list-data-loaded="onListDataLoaded"
      :on-delete-successed="onDeleteSuccessed"
      :on-selected-rows-change="onSelectedRowsChange"
    />
  </div>
</template>

<script>
export default {
    props: {
        type: { type: String, default: function() { return '' } }
    },
    data: function() {
        return {
            loginUser: this.$store.getters.loginUser,
            urlParams: this.$route.meta.params,
            moduleInfo: {
                'formTemplate': 'dcontent/busiformurl?vwtype=W&url=/portal/cms/article/form.html',
                'winWidth': 850,
                'delUrl': 'portal/cms/article/delete',
                'moduleCode': 'article',
                'winHeight': 600,
                'listDataUrl': 'portal/cms/article/listdata'
            },
            tbColumns: [],
            listpageBtns: [],
            tbs: [
                { 'field': 'state', 'checkbox': true, 'width': '45px', 'sortable': false, 'align': 'center' },
                { 'listAdvSearchElement': '', 'field': 'index', 'width': '45px', 'sortable': false, 'propType': '', 'align': 'center', 'title': '序号', 'searchable': false },
                { 'listAdvSearchElement': 'input', 'field': 'title', 'width': '', 'sortable': true, 'propType': 'String', 'align': 'left', 'title': '文章标题', 'searchable': true },
                { 'listAdvSearchElement': 'input', 'field': 'cateName', 'width': '100px', 'sortable': true, 'propType': 'String', 'align': 'left', 'title': '分类', 'searchable': true },
                { 'listAdvSearchElement': '', 'field': 'isHeadlines', 'width': '100px', 'elementFormatter': '0：否\r\n1：是\r\n9：取消头条\r\n', 'sortable': true, 'propType': 'Short', 'align': 'center', 'title': '是否头条 ', 'searchable': false },
                { 'listAdvSearchElement': 'input', 'field': 'creator', 'width': '100px', 'sortable': true, 'propType': 'String', 'align': 'center', 'title': '创建人', 'searchable': true },
                // { 'propFormatter': 'format：yyyy-MM-dd HH:mm', 'listAdvSearchElement': 'date', 'field': 'createTime', 'width': '130px', 'sortable': true, 'propType': 'java.util.Date', 'align': 'center', 'title': '创建时间', 'searchable': true },
                { 'propFormatter': 'format：yyyy-MM-dd HH:mm', 'listAdvSearchElement': 'date', 'field': 'publishTime', 'width': '130px', 'sortable': true, 'propType': 'java.util.Date', 'align': 'center', 'title': '发布时间', 'searchable': true },
                { 'listAdvSearchElement': '', 'field': 'publishStatus', 'width': '100px', 'propFormatter': 'component：@/wapp/xxfb/article/components/BtnOperation', 'sortable': false, 'propType': 'Short', 'align': 'center', 'title': '状态 ', 'searchable': false },
                { 'listAdvSearchElement': '', 'field': 'operation', 'width': '130px', 'propFormatter': 'component：@/wapp/xxfb/article/components/BtnOperation', 'sortable': false, 'propType': 'Short', 'align': 'center', 'title': '操作', 'searchable': false }

            ],
            btns: [
                { 'btnName': '新增', 'btnIcon': 'plus', 'btnClick': 'addArticle', 'btnPermission': 'addObject', 'id': 'btn_add', 'btnType': 'toolbar' },
                { 'btnName': '审核通过', 'btnIcon': 'edit-outline', 'btnClick': 'batchUpdateStatus(\'\',\'review\')', 'btnPermission': 'batchUpdateStatus', 'id': 'btn_batchUpdateStatus', 'btnType': 'toolbar' },
                { 'btnName': '发布', 'btnIcon': 'check', 'btnClick': 'batchUpdateStatus(\'\',\'publish\')', 'btnPermission': 'batchUpdateStatus', 'id': 'btn_batchUpdateStatus', 'btnType': 'toolbar' },
                { 'btnName': '删除', 'btnIcon': 'close', 'btnClick': 'batchUpdateStatus(\'\',\'delete\')', 'btnPermission': 'batchUpdateStatus', 'id': 'btn_deleteIds', 'btnType': 'toolbar' }
            ],
            busiformBtns: [],
            formTitle: '信息发布',
            treeNode: '',
            selectionIds: [],
            roles: [],
            reviewType: true,
            publishType: true,
            isSendReview: true
        }
    },
    computed: {
    },
    watch: {
    },
    created: function() {
        this.roles = this.$store.state.user.roles
        if (this.roles.indexOf('article_audit') === -1 && this.roles.indexOf('article_audit_hg') === -1) { // 不是文章审核员
            if (this.$route.meta.params.indexOf('isHeadlines') > -1) { // 是头条
                this.listpageBtns = [this.btns[3]]
                this.tbColumns = [this.tbs[0], this.tbs[1], this.tbs[2], this.tbs[3], this.tbs[6], this.tbs[7], this.tbs[8]]
            } else {
                this.listpageBtns = [this.btns[0], this.btns[3]]
                this.tbColumns = [this.tbs[0], this.tbs[1], this.tbs[2], this.tbs[6], this.tbs[7], this.tbs[8]]
            }
        } else {
            if (this.$route.meta.params.indexOf('isHeadlines') > -1) {
                this.listpageBtns = [this.btns[1], this.btns[3]]
                this.tbColumns = [this.tbs[0], this.tbs[1], this.tbs[2], this.tbs[3], this.tbs[6], this.tbs[7], this.tbs[8]]
            } else {
                this.listpageBtns = this.btns
                this.tbColumns = [this.tbs[0], this.tbs[1], this.tbs[2], this.tbs[6], this.tbs[7], this.tbs[8]]
            }
        }
        // if (this.type === 2) { // 是单位公告
        //     this.tbColumns.splice(3, 2)
        // }

        // 列表页面配置ID
        // this.moduleInfo.listpageViewUrl = 'portal.cms.article.list.vue'
        const _this = this
        this.listpageBtns.forEach(function(btn) {
            btn.btnParams = null
            if (typeof btn.btnClick === 'string') {
                let btnClick = btn.btnClick
                if (btn.btnClick.indexOf('(') !== -1) {
                    let btnParams = btnClick.substring(btnClick.indexOf('(') + 1, btnClick.lastIndexOf(')'))
                    if (btnParams !== '') {
                        btnParams = btnParams.replace(/'/g, '').split(',')
                        btn.btnParams = btnParams
                    }
                    btnClick = btnClick.split('(')[0]
                }
                if (_this[btnClick]) {
                    btn.btnClick = _this[btnClick]
                }
            }
        })
        this.$bus.on('treeClick', this.treeClick)
        this.$bus.on('batchUpdateStatus', this.batchUpdateStatus)
    },
    beforeDestroy: function() {
        this.$bus.off('treeClick', this.treeClick)
        this.$bus.off('batchUpdateStatus', this.batchUpdateStatus)
    },
    mounted: function() {
    },
    methods: {
        treeClick(treeNode) {
            this.treeNode = treeNode
            this.$refs.datatablelist.loadListdata()
        },
        // 新增
        addArticle() {
            if (this.type === 1) {
                if (this.treeNode === '' || this.treeNode.id === '0') {
                    this.$alert('请选择新闻分类', '提示', {
                        confirmButtonText: '确定',
                        type: 'warning'
                    })
                    return
                } else {
                    window.open('/#/article?canEdit=1&type=' + this.type + '&cateId=' + this.treeNode.id + '&cateName=' + this.treeNode.name)
                }
            } else if (this.type === 2) {
                window.open('/#/article?canEdit=1&type=' + this.type)
            } else if (this.type === 3) {
                window.open('/#/article?canEdit=1&type=' + this.type + '&cateName=大事记')
            } else if (this.type === 4) {
                window.open('/#/article?canEdit=1&type=' + this.type + '&cateName=文件制度')
            }
        },
        onCellClick(row, column, innerText, cellIndex) {
            window.open('/#/article?type=' + this.type + '&canEdit=0&id=' + row.id)
        },
        onSelectedRowsChange(selection) {
            const ids = []
            selection.forEach(row => {
                ids.push(row.id)
            })
            this.selectionIds = ids
            for (let i = 0; i < selection.length; i++) {
                if (selection[i].reviewStatus === 0) {
                    this.isSendReview = false
                }
                if (selection[i].reviewStatus === null || selection[i].reviewStatus === 2) {
                    this.reviewType = false
                    break
                } else {
                    this.reviewType = true
                }
            }
            for (let i = 0; i < selection.length; i++) {
                if (selection[i].reviewStatus === 0) {
                    this.isSendReview = false
                } else {
                    this.isSendReview = true
                }
                if (selection[i].publishStatus === 1) {
                    this.publishType = true
                } else {
                    this.publishType = false
                    break
                }
            }
        },
        // 批量修改
        batchUpdateStatus(ids, actionType) {
            // 选择处理文章要
            if (this.selectionIds.length === 0) {
                if (ids === '' || ids === null) {
                    this.$alert('请选择需要处理的文章', '提示', {
                        confirmButtonText: '确定',
                        type: 'warning'
                    })
                    return
                } else {
                    ids = [ids]
                }
            } else {
                ids = this.selectionIds
            }
            if (actionType === 'review') {
                if (!this.reviewType) {
                    this.$alert('有未送审核的文章，请先送审核！', '提示', {
                        confirmButtonText: '确定',
                        type: 'warning'
                    })
                    return
                } else if (this.publishType) {
                    this.$alert('有已发布的文章不需要再审核！', '提示', {
                        confirmButtonText: '确定',
                        type: 'warning'
                    })
                    return
                }
            } else if (actionType === 'publish') {
                if (!this.reviewType || !this.isSendReview) {
                    this.$alert('有未审核通过的文章，请先审核！', '提示', {
                        confirmButtonText: '确定',
                        type: 'warning'
                    })
                    return
                }
            }

            let msg = ''
            let reviewStatus = null
            let publishStatus = null
            let deleteSatus = null
            let successmes = ''
            if (actionType === 'delete') {
                msg = '确认要删除文章吗？'
                deleteSatus = 1
                successmes = '删除成功！'
            } else if (actionType === 'send') {
                msg = '确认要送审核吗？'
                reviewStatus = 0
                publishStatus = 0
                successmes = '已送审核！'
            } else if (actionType === 'review') {
                msg = '确认审核通过吗？'
                reviewStatus = 1
                publishStatus = 0
                successmes = '审核成功！'
            } else if (actionType === 'reject') {
                msg = '确认审核不通过吗？'
                reviewStatus = 2
                publishStatus = 0
                successmes = '审核成功！'
            } else if (actionType === 'publish') {
                msg = '确认发布文章吗？'
                reviewStatus = 1
                publishStatus = 1
                successmes = '发布成功！'
            } else if (actionType === 'cancelPublish') {
                msg = '确认取消发布吗？'
                reviewStatus = 1
                publishStatus = 0
                successmes = '取消发布成功！'
            }

            this.$confirm(msg, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http({
                    method: 'PUT',
                    contentType: 'application/x-www-form-urlencoded',
                    params: { 'ids': ids.join(','), 'reviewStatus': reviewStatus, 'publishStatus': publishStatus, 'deleteStatus': deleteSatus },
                    url: 'portal/cms/article/batchUpdateStatus'
                }).then(response => {
                    if (response.code === 'success') {
                        this.$message({ message: successmes, type: 'success' })
                        this.$nextTick(() => {
                            this.$bus.emit('refreshListData')
                        })
                    } else {
                        this.$message.error({ message: response.message })
                    }
                })
            }).catch(() => {

            })
        },
        onListDataBeforeLoad($scop, params) {
            params.orderBy = 'createTime desc'
            params.urlsearch = 'type:' + this.type + ';deleteStatus:0;orgCode:' + this.loginUser.orgCode
            if (this.$route.meta.params.indexOf('isHeadlines') > -1) {
                params.urlsearch += ';isHeadlines:1'
            }
            if (this.roles.indexOf('article_audit') === -1 && this.roles.indexOf('article_audit_hg') === -1) {
                params.urlsearch += ';creatorId:' + this.loginUser.personId
            }
            if (this.treeNode !== '' && this.treeNode.id !== '0') {
                params.urlsearch += ';cateId:' + this.treeNode.id
            }

            delete params.type
        }
    }
}
</script>

<style scoped>
</style>
